import {
    APPOINTMENT_SERVICE_REQUEST, APPOINTMENT_SERVICE_RECEIVE, APPOINTMENT_SERVICE_FAILURE
} from './../constants/appointment';


const initialState = {
    data: [],
    loading: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case APPOINTMENT_SERVICE_REQUEST:
            return state;

        case APPOINTMENT_SERVICE_RECEIVE:
            return { ...state, data: action.payload };

        case APPOINTMENT_SERVICE_FAILURE:
            return state;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// frontend/src/modules/mobile/reducers/appointment.js